import Invitation from "@higher/models/Invitation";

import { stateSubscriptionById } from "./stateSubscriptionById";

const Collection = "invitations";

export default stateSubscriptionById<Invitation>("InvitationById", Collection);
